import { render } from "./machine_card.vue?vue&type=template&id=2013814b&scoped=true&ts=true"
import script from "./machine_card.vue?vue&type=script&lang=ts"
export * from "./machine_card.vue?vue&type=script&lang=ts"

import "./machine_card.vue?vue&type=style&index=0&id=2013814b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2013814b"]])

export default __exports__